; (function (angular, _) {
    'use strict'

    class AddressDisplayRowController {
        constructor(
            // Angular
            // Libs
            // Managers
            // Services
            UtilService
            // Const
            // Resolved
        ) {
            // DI
            this.utilService = UtilService,
            this.init()
        }

        init() {
            this.getLodgement(this.address)
        }

        getLodgement(address) {
            return this.utilService.formatAddressLodgement(address)
        }

        notInFrance(address) {
            return !address || !address.country || address.country.toLowerCase() !== 'france'
        }
    }

    AddressDisplayRowController.$inject = [
        // Angular
        // Libs
        // Managers
        // Services
        'UtilService'
        // Const
        // Resolved
    ]

    angular.module('kilo.common.components')
        .component('addressDisplayRow', {
            templateUrl: '/app/common/components/address-display-row/address-display-row.template.html',
            bindings: {
                elt: '='
            },
            controller: AddressDisplayRowController
        })

})(window.angular, window._)
